import React, { ReactElement } from "react";
import Grid from "@material-ui/core/Grid";

import {
    Button,
    Typography,
} from "@material-ui/core";
import { ExportRoutergeraeteToExcel } from "../../../features/excelExport/ExportToExcel";
import { useAppSelector, useAppDispatch } from "../../../app/hooks";
import {
    selectRoutergeraeteListe,
    selectRoutergeraettypen,
    selectEditEntry,
    startNewEntry,
    selectListLoading,
} from "./routergeraetSlice";
import { useStyles } from "./routergeraetStyles";
import { routergeraet, routergeraettyp } from "../../../utils/apiTypes";
import { globalStyles } from "../../../assets/globalStyles";
import { rollen, isAuthorized } from "../../../utils/auth/authConfig";


export default function RoutergeraetActionheader(): ReactElement {
    const dispatch = useAppDispatch();

    const classes = {
        ...useStyles(),
        ...globalStyles(),
    };

    const rows: routergeraet[] = useAppSelector(selectRoutergeraeteListe),
        routergeraetetypSelectList: routergeraettyp[] = useAppSelector(selectRoutergeraettypen),
        editEntry: boolean = useAppSelector(selectEditEntry),
        listLoading: boolean = useAppSelector(selectListLoading);

    return (
        <React.Fragment>
            <Grid container spacing={2} style={{ marginBottom: "10px", padding: "0px", paddingLeft: "0px", paddingRight: "16px" }}>
                <Grid item md={3} >
                    <Typography color="primary" variant="h6" className={classes.typoH6Style} style={{ marginLeft: "20px" }} >
                        Routergeräte Übersicht
                    </Typography>
                </Grid>
                <Grid item md={3} />
                <Grid item md={3} />
                <Grid item md={3}>
                    {isAuthorized([rollen.admin, rollen.betrieb]) ?
                        <Button
                            variant="contained"
                            onClick={() => {
                                dispatch(startNewEntry());

                            }
                            }
                            color="secondary"
                            className={classes.showDuoButton}
                            disabled={editEntry}
                        >
                            Neuer Router
                        </Button>
                        : ""}
                    <Button
                        variant="contained"
                        onClick={() => {
                            ExportRoutergeraeteToExcel(rows.map(x => { return { rm: routergeraetetypSelectList.find((rt: routergeraettyp) => rt.id == x.typ)?.hersteller, rtyp: routergeraetetypSelectList.find((rt: routergeraettyp) => rt.id == x.typ)?.typ, ...x } }), "routergeraete")
                        }}
                        color="default"
                        className={classes.showDuoButton}
                        disabled={editEntry || listLoading}
                    >
                        Export
                    </Button>
                </Grid>
            </Grid>
        </React.Fragment>
    );
}
